import { Outlet } from 'react-router-dom';
import { useLayout } from './context';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { Toolbar, ToolbarActions, ToolbarHeading } from './toolbar';
import { ToolbarMenu } from './toolbar-menu';
import { ToolbarMenuMobile } from './toolbar-menu-mobile';
import { HeaderBreadcrumbs } from './header-breadcrumbs';
import { BreadcrumbProvider } from './breadcrumb-context';
import { MenuConfig } from '@/config/types';
import { useUser } from '@/hooks/useAuth';
import { CompactWeatherCard } from '@/components/weather/CompactWeatherCard';
import { PortalType } from './sidebar-secondary';

interface WrapperProps {
  menuConfig?: MenuConfig;
  portalType?: PortalType;
  enabledModules?: string[];
  onLogout?: () => void;
  isLogoutPending?: boolean;
}

export function Wrapper({ 
  menuConfig, 
  portalType = 'platform', 
  enabledModules = ['core'],
  onLogout, 
  isLogoutPending 
}: WrapperProps) {
  const {isMobile} = useLayout();
  const user = useUser();
  const displayName =
    user?.full_name ||
    `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim() ||
    user?.email ||
    'User';

  return (
    <BreadcrumbProvider>
      <Header onLogout={onLogout} isLogoutPending={isLogoutPending} portalType={portalType} enabledModules={enabledModules} />
      {!isMobile && (
        <Sidebar 
          menuConfig={menuConfig} 
          portalType={portalType} 
          enabledModules={enabledModules}
          onLogout={onLogout} 
          isLogoutPending={isLogoutPending} 
        />
      )}      

      <div className="grow overflow-y-auto pt-(--header-height-mobile) lg:pt-[calc(var(--header-height)+var(--toolbar-height))] lg:ps-(--sidebar-width) lg:in-data-[sidebar-open=false]:ps-(--sidebar-collapsed-width) transition-all duration-300">
        <Toolbar>
          <ToolbarHeading>
            {isMobile ? <ToolbarMenuMobile /> : <ToolbarMenu />}
            {!isMobile && (
              <span className="text-sm text-muted-foreground">
                Welcome, <span className="font-medium text-foreground">{displayName}</span>
              </span>
            )}
          </ToolbarHeading>
          <ToolbarActions>
            {!isMobile && <CompactWeatherCard />}
          </ToolbarActions>
        </Toolbar>

        <main className="grow" role="content">
          {isMobile && <HeaderBreadcrumbs portalType={portalType} />}
          <Outlet />
        </main>
      </div>
    </BreadcrumbProvider>
  );
}
